function carousel() {
    const root = document.querySelector('[data-carousel]');
    if (!root) return;

    const slides = root.querySelectorAll('[data-slide]');
    const dots = document.querySelectorAll('[data-carousel-dots] button');
    if (slides.length < 2) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer;

    const show = function (next) {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === index);
            dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
    };

    const start = function () {
        if (reducedMotion) return;
        stop();
        timer = setInterval(() => show(index + 1), 6000);
    };

    const stop = function () {
        clearInterval(timer);
    };

    dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            show(i);
            start();
        });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    start();
}
